
import React, { Component}  from 'react';

import { DetailProvider, DetailContext } from 'core/DetailProvider';
import { FormContext, FormProvider } from 'core/FormProvider';
import Layout from 'components/Dashboard/Layout';
import { YellowButton } from 'ui/Button';
import { TariffBaseForm } from './FormBase';


export default class TariffDetailBase extends Component {

  onLoaded = (item) => {
    document.title = `Тариф ${item.name}`;
  };

  render() {
    const { match } = this.props;
    return (
      <DetailProvider
        url={`tariff/${match.params.id}`}
        onLoaded={(item) => this.onLoaded(item)}
      >
        <DetailContext.Consumer>
          {detailContext => {
            let { item } = detailContext;
            return (
              <FormProvider
                url={item.meta.url}
                postSaveMessage={'Тариф обновлен'}
                postSave={(item) => detailContext.updateItem(item)}
                item={item}
              >
                <FormContext.Consumer>
                {formContext => {
                  const { loading } = formContext;
                  return (
                    <Layout>
                      <Layout.Header
                        title={'Редактирование тарифа'}
                        backUrl={'/tariff'}
                      />

                      <Layout.ContentSimple>

                        <TariffBaseForm formContext={formContext} />

                        <div className={'mt-30'}>
                          <YellowButton
                            onClick={(e) => formContext.handleSubmit(e)}
                            disabled={loading}
                            size={'large'}
                          >
                            Обновить тариф
                          </YellowButton>
                        </div>
                      </Layout.ContentSimple>

                    </Layout>
                  )
                }}
                </FormContext.Consumer>
              </FormProvider>
            )
          }}
        </DetailContext.Consumer>
      </DetailProvider>
    )
  }
}
